import React, { useContext, useRef, useState } from "react";
import { PaletteContext } from "./palette_context";
import { NAME_KEY, KIND_KEY, SHOW_KEY, KINDS } from "@/lib/printess/constants";
import EditableItemProperty from "./editable_item_property";
import SaveButton from "./save_button";
import ShowButton from "./show_button";
import CategoryControls from "./category_controls";
import ExpandCollapse from "./expand_collapse";
import { getCategoryChildren } from "./palette_helpers";

const CategoryRow = ({ item, onClick, onSave }) => {
  const { items, setItems } = useContext(PaletteContext);
  const [properties, setProperties] = useState({});
  const pendingChangesRef = useRef(false);

  const handlePropertyChanged = (property, newValue) => {
    pendingChangesRef.current = true;
    setProperties((prev) => ({ ...prev, [property]: newValue }));
  };

  const handleSave = () => {
    onSave({ ...item, ...properties, [SHOW_KEY]: true });
    pendingChangesRef.current = false;
  };

  // Expand/collapse all children of this category
  const expandOrCollapseItems = (collapsed) => {
    const affectedKeys = [
      item.key,
      ...getCategoryChildren(items, item).map((p) => p.key),
    ];
    setItems((prev) =>
      prev.map((it) =>
        affectedKeys.includes(it.key) ? { ...it, _collapsed: collapsed } : it,
      ),
    );
  };

  return (
    <div
      className="palette-category palette-row-main"
      key={item.key}
      data-kind={item[KIND_KEY]}
      data-show={item[SHOW_KEY]}
      onClick={onClick}
    >
      <div className="palette-cell palette-cell--icon" key="expand">
        <ExpandCollapse
          collapsed={item._collapsed}
          handleExpand={() => expandOrCollapseItems(false)}
          handleCollapse={() => expandOrCollapseItems(true)}
        />
      </div>
      <div className="palette-cell palette-name-cell palette-category-name" key="name">
        <EditableItemProperty
          value={item[NAME_KEY]}
          property={NAME_KEY}
          onSave={handleSave}
          onChange={(newValue) => handlePropertyChanged(NAME_KEY, newValue)}
        />
      </div>
      <div className="palette-cell palette-actions-cell" key="actions">
        <CategoryControls item={item} />
        {pendingChangesRef.current && <SaveButton doSave={handleSave} />}
        {!pendingChangesRef.current && <ShowButton item={item} />}
      </div>
    </div>
  );
};

export default CategoryRow;
